import { useRoutes } from 'react-router-dom';
import { AddSubscription } from '../pages/Add-subscription/Add-subscription';
import { CreateInsurance } from '../pages/CreateInsurance/CreateInsurance';
import { DeleteUser } from '../pages/Delete-user/Delete-user';
import { PaymentsAndBilling } from '../pages/Payments-billing/Payments-billing';
import { Profile } from '../pages/Profile/Profile';
import { Properties } from '../pages/Properties/Properties';
import { SearchUser } from '../pages/SearchUser/SearchUser';
import { SellInsuranceMassivelyIdentifier } from '../pages/Sell-insurance-massively-identifier/SellInsuranceMassivelyIdentifier';
import { ServicesHistory } from '../pages/Services-history/Service-history';
import { SettingsOptions } from '../pages/Settings-options/Settings-options';
import { SubscriptionDetails } from '../pages/SubscriptionDetails/SubscriptionDetails';
import { Subscriptions } from '../pages/Subscriptions/Subscriptions';
import { SubscriptionsGuard } from '../pages/Subscriptions/guards/Subscriptions.guard';
import { UserProductEdit } from '../pages/UserProductEdit/UserProductEdit';
import { SubscriptionEdit } from '../pages/SubscriptionEdit/SubscriptionEdit';

export const SettingsRouter = () => {
  const routes = useRoutes([
    {
      children: [
        {
          path: '/profile',
          element: <Profile />,
        },
        {
          path: '/properties',
          element: <Properties />,
        },
        {
          path: '/payments',
          element: <PaymentsAndBilling />,
        },
        {
          path: '/subscriptions',
          element: (
            <SubscriptionsGuard>
              <Subscriptions />
            </SubscriptionsGuard>
          ),
        },
        {
          path: '/subscriptions/edit/:subId/version/:subVersion',
          element: <SubscriptionEdit />,
        },
        {
          path: '/subscriptions/:subId/version/:subVersion',
          element: <SubscriptionDetails />,
        },
        {
          path: '/subscriptions/:subId/version/:subVersion/edit/:userProductId',
          element: <UserProductEdit />,
        },
        {
          path: '/subscriptions/add-subscription',
          element: <AddSubscription />,
        },
        {
          path: '/subscriptions/create-insurance',
          element: <CreateInsurance />,
        },
        {
          path: '/services-history',
          element: <ServicesHistory />,
        },
        {
          path: '/delete-user',
          element: <DeleteUser />,
        },
        {
          path: '/search-user',
          element: <SearchUser />,
        },
        {
          path: '/sell-insurance-massively-identifier',
          element: <SellInsuranceMassivelyIdentifier />,
        },
        {
          path: '/*',
          element: <SettingsOptions />,
        },
      ],
    },
  ]);
  return routes;
};
